/***
 * 创建人：段锐
 * 时间：2019-06-10
 * 描述：对手机号码进行验证
 * 更新记录: 
 */
import { Directive } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[validatePhone]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ValidatorTelephoneDirective,
      multi: true
    }
  ]
})
export class ValidatorTelephoneDirective implements Validator{
    constructor(){
        
    }
    validate(control: AbstractControl): { [key: string]: any } {
      let reg=/^1[3|4|5|6|7|8|9][0-9]{9}$/;//正则表达式
      let telephone=control.value;//取得输入框的值
      if(!telephone || telephone==""){ //为空时不验证
        return null
      }
      if(reg.test(telephone)){
        return null;
      }
        return {
          validatePhone:"手机号码格式不匹配"
        };
      }
}

